import { CycleOutcomeWriteError } from "../../cycles/presenters/patientOutcomeWrite";
import { getApiErrorMessage } from "../../api/api-error";
import type { ApiClient } from "@src/packages/api/louise-api";
import type {
  CyclePregnancyStatusAggregate,
  CyclePregnancyStatusWrite,
} from "./useCyclePregnancyStatus";

export class CyclePregnancyStatusWriteError extends CycleOutcomeWriteError {
  constructor(message: string, status: number) {
    super(message, status);
    this.name = "CyclePregnancyStatusWriteError";
  }
}

export async function recordCyclePregnancyStatus(
  client: ApiClient,
  input: { cycleId: string; body: CyclePregnancyStatusWrite },
): Promise<CyclePregnancyStatusAggregate> {
  const { data, error, response } = await client.POST(
    "/cycles/{cycleId}/pregnancy-status",
    {
      params: { path: { cycleId: input.cycleId } },
      body: input.body,
    },
  );
  if (response.ok && data) return data.data;
  throw new CyclePregnancyStatusWriteError(
    getApiErrorMessage(error, "Failed to record the pregnancy status"),
    response.status,
  );
}
